module.exports = __webpack_public_path__ + "img/edit.bfba0bba.svg";